import { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { getOrder } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";
import { OrderDetails } from "@/pages/PaymentSuccess";

export default function OrderConfirmed() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const params = new URLSearchParams(useLocation().search);
  const confirmed = params.get("confirmed") === "1";

  useEffect(() => {
    getOrder(orderId).then(o => { setOrder(o); setLoading(false); }).catch(() => setLoading(false));
  }, [orderId]);

  return (
    <div className="min-h-screen island-pattern">
      <Navbar />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16">
        <div className="bg-white rounded-3xl border border-[#E5D9C5] shadow-[0_20px_60px_rgba(44,36,27,0.08)] p-8 slide-up" data-testid="order-confirmed-card">
          {loading && (
            <div className="text-center">
              <Loader2 className="w-14 h-14 mx-auto text-[#D9381E] animate-spin" />
            </div>
          )}
          {!loading && order && (
            <>
              <div className="mx-auto w-16 h-16 rounded-full bg-[#2C5E3B] flex items-center justify-center">
                <CheckCircle2 className="w-9 h-9 text-white" />
              </div>
              <h1 className="mt-5 font-display font-extrabold text-3xl text-[#2C241B] text-center">
                {confirmed ? "Order received!" : "Your order"}
              </h1>
              <p className="mt-2 text-[#7A6C5D] text-center">
                Thanks {order.customer_name.split(" ")[0]}, {order.payment_status === "paid" ? "your payment is confirmed." : "please pay at pickup."}
              </p>
              <OrderDetails order={order} />
              <div className="mt-6 text-center">
                <Link to="/" data-testid="confirmed-back-home-btn" className="inline-block cta-primary rounded-full px-6 py-3 font-display font-extrabold text-sm">Order More</Link>
              </div>
            </>
          )}
          {!loading && !order && (
            <div className="text-center text-[#7A6C5D]">Order not found.</div>
          )}
        </div>
      </div>
    </div>
  );
}
